(() => {
  if (window.hpBuyBoxAccordionV2) return;
  window.hpBuyBoxAccordionV2 = true;
  const running = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const summary = event.target.closest('summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (!details.matches('details.hp-buybox-accordion, details.hp-product-safety')) return;
    if (!details.closest('.product-details')) return;
    const content = details.querySelector(':scope > .hp-buybox-accordion__content, :scope > .hp-product-safety__content');
    if (!content || event.defaultPrevented || reducedMotion.matches || typeof content.animate !== 'function') return;
    event.preventDefault();
    const previous = running.get(details);
    const opening = previous ? !previous.opening : !details.open;
    const wasOpen = details.open;
    const startRect = content.getBoundingClientRect();
    const startStyle = getComputedStyle(content);
    const start = {
      height: wasOpen ? startRect.height + 'px' : '0px',
      paddingTop: wasOpen ? startStyle.paddingTop : '0px',
      paddingBottom: wasOpen ? startStyle.paddingBottom : '0px',
      opacity: wasOpen ? startStyle.opacity : '0'
    };
    if (previous) previous.animation.cancel();
    details.open = true;
    const expandedHeight = content.getBoundingClientRect().height;
    const expandedStyle = getComputedStyle(content);
    const end = opening ? {
      height: expandedHeight + 'px',
      paddingTop: expandedStyle.paddingTop,
      paddingBottom: expandedStyle.paddingBottom,
      opacity: '1'
    } : { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: '0' };
    const animation = content.animate([start, end], {
      duration: 360,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      fill: 'both'
    });
    running.set(details, { animation, opening });
    animation.onfinish = () => {
      if (running.get(details)?.animation !== animation) return;
      details.open = opening;
      animation.cancel();
      running.delete(details);
    };
  }, true);
})();
